"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var subscriptionSlice_1 = require("../../../features/subscription/subscriptionSlice");
var react_i18next_1 = require("react-i18next");
var moment_1 = __importDefault(require("moment"));
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var SubscriptionPlanForm = function (_a) {
    var daysCountStep = _a.daysCountStep, maxDaysCount = _a.maxDaysCount, subscriptionBasePrice = _a.subscriptionBasePrice;
    var _b = react_1.useState(1), count = _b[0], setCount = _b[1];
    var dispatch = react_redux_1.useDispatch();
    var t = react_i18next_1.useTranslation('common').t;
    var increaseCount = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (count * daysCountStep >= maxDaysCount) {
                return [2 /*return*/];
            }
            setCount(function (prevCount) { return prevCount + 1; });
            return [2 /*return*/];
        });
    }); };
    var decreaseCount = function () {
        if (count * daysCountStep <= daysCountStep) {
            return;
        }
        setCount(function (prevCount) { return prevCount - 1; });
    };
    react_1.useEffect(function () {
        dispatch(subscriptionSlice_1.setSubscriptionQty(count));
    }, [count]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.form },
        react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.form_item, styles_module_scss_1.default.counter) },
            react_1.default.createElement("p", { className: styles_module_scss_1.default.label }, t('SUBSCRIPTION_PLANS_MODAL.FORM.DAYS_COUNT')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.counter_actions },
                react_1.default.createElement("button", { className: classnames_1.default('btn btn-primary', styles_module_scss_1.default.counter_btn), disabled: count * daysCountStep === daysCountStep, onClick: decreaseCount },
                    react_1.default.createElement("i", { className: 'icon-chevron-left' })),
                react_1.default.createElement("p", { className: styles_module_scss_1.default.count }, count * daysCountStep),
                react_1.default.createElement("button", { className: classnames_1.default('btn btn-primary', styles_module_scss_1.default.counter_btn), disabled: count * daysCountStep === maxDaysCount, onClick: increaseCount },
                    react_1.default.createElement("i", { className: 'icon-chevron-right' })))),
        react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.form_item, styles_module_scss_1.default.completion_date) },
            react_1.default.createElement("p", { className: styles_module_scss_1.default.label }, t('SUBSCRIPTION_PLANS_MODAL.FORM.EXPIRATION_DATE')),
            react_1.default.createElement("p", { className: styles_module_scss_1.default.formatted_date }, moment_1.default()
                .add(count * daysCountStep, 'day')
                .format('MM/DD/YYYY'))),
        react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.form_item, styles_module_scss_1.default.subscriptionPrice) },
            react_1.default.createElement("p", { className: styles_module_scss_1.default.label }, t('SUBSCRIPTION_PLANS_MODAL.FORM.PRICE')),
            react_1.default.createElement("p", { className: styles_module_scss_1.default.formatted_price }, subscriptionBasePrice * count + " AMD"))));
};
exports.default = SubscriptionPlanForm;
